import Icon from '../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import './style.scss';

interface IProps {
  lat?: number;
  lng?: number;
  name: Icons;
  className?: string;
  iconClassName?: string;
  size?: number;
  onClick?: () => void;
}
const PinIndicator = (props: IProps) => {
  const size = props.size || 24;
  return (
    <div onClick={props.onClick} className={`pinindicator ${props.className || ''}`}>
      <Icon
        size={size}
        style={{ left: `calc(50% - ${size / 2}px)`, top: `calc(50% - ${size}px)` }}
        className={props.iconClassName}
        name={props.name || Icons.Pin}
      />
    </div>
  );
};

export default PinIndicator;
